import request from "./config";

export default class ProductService {
  static create(data) {
    return request({
      url: "/product",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/product/${id}`,
      method: "patch",
      data,
    });
  }
  static delete(id) {
    return request({
      url: `/product/${id}`,
      method: "delete",
    });
  }
  static  find(params) {
    return request({
      url: `/product`,
      method: "get",
      params:params
    });
  }
}
